// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__ZZRX0","borderWrapper":"header_borderWrapper__4o8ZS","content":"header_content__NvR9O","title":"header_title__chy1G"};